
import { getMethod, getMethodByCallBack } from "../../../store/api/CommonFunctions";
import { postMethodByCallBack, translateError, serverUrl, getheader, setErrorDialog, getMethodByDispatcher, cacheTypes, postMethodByDispatcher } from "../../../store/api/CommonFunctions";

export const nationalUrl = serverUrl + "api/CustomersAPI/SearchNationalCode";
export function addNewCustomer(data, fn) {
  const _header = getheader();
  let customer = data;
  data = JSON.stringify(data)
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    })

    fetch(serverUrl + "api/CustomersAPI/AddCustomer/", {
      body: data,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message || res === "ErrorMobile" || res === "ErrorPhone" || res === "ErrorNationalCode") {
          const msg = res.Message ?? res;
          setErrorDialog(dispatch, msg, "مشتری جدید");
          //if (!res.Message) {
          fn();
          //}
          return;
        }

        customer.ID = Number(res);
        fn(customer);
        dispatch({
          type: "FETCH_CUSTOMER",
          data: customer
        })
        //setErrorDialog(dispatch, "success", "ایجاد مشتری جدید");
      }).catch(err => {
        console.error('[ADD_CUSTOMER]', err);
        //alert("اشکال در انجام عملیات");
      });
  }
}
export function addNewCustomers(data, updateFoundItems, fn) {

  return dispatch => {
    const _header = getheader();
    let customer = data;
    data = JSON.stringify(data);
    fetch(serverUrl + "api/CustomersAPI/AddCustomers/" + updateFoundItems, {
      body: data,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ثبت گروهی مشتریان");
          return;
        }

        if (fn) {
          fn(customer);
        }
        setErrorDialog(dispatch, "success", "ثبت گروهی مشتریان");
      }).catch(err => {
        console.error('[ADD_CUSTOMERS]', err);
        setErrorDialog(dispatch, "error", "ثبت گروهی مشتریان");
      });
  }
}
export function editCustomerInfo(data, fn) {
  const _header = getheader();
  const editedInfo = data;
  data = JSON.stringify(data)
  return dispatch => {

    fetch(serverUrl + "api/CustomersAPI/EditCustomer/", {
      body: data,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message || res === "ErrorMobile" || res === "ErrorPhone" || res === "ErrorNationalCode") {
          const msg = res.Message ?? res;
          setErrorDialog(dispatch, msg, "ویرایش اطلاعات مشتری");
          //if (!res.Message) {
          fn();
          //}
          return;
        }
        setErrorDialog(dispatch, "success", "ویرایش اطلاعات مشتری");
        fn();
        dispatch({
          type: "FETCH_CURRENT_CUSTOMER",
          data: editedInfo
        });
        dispatch({
          type: "FETCH_CUSTOMER",
          data: editedInfo
        })
      }).catch(err => {
        console.error('[Edit_CUSTOMER]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
      });
  }
}
export function setCustomerEmpty() {
  return dispatch => {
    dispatch({
      type: "FETCH_CUSTOMER",
      data: undefined
    });
  }
}
export function getCutomerByID(id) {
  const _header = getheader();
  return dispatch => {
    dispatch({
      type: "FETCH_CUSTOMER",
      data: "PENDING"
    });
    if (!id || Number(id) === 0) {
      return dispatch({
        type: "FETCH_CUSTOMER",
        data: null
      })
    }
    fetch(serverUrl + "api/CustomersAPI/GetCustomerByID?Id=" + id, {
      headers: _header,
      method: "GET"
    }).then(resp => resp.json())
      .then(resp => {
        if (resp.Message) {
          setErrorDialog(dispatch, resp.Message, "دریافت اطلاعات مشتری");
          resp = null;
        }
        return dispatch({
          type: "FETCH_CUSTOMER",
          data: resp
        })
      }).catch(err => {
        console.log("[FETCH_CURRENT_CUSTOMER]", err);
      })
  }
}
export function getCustomerByID(id, onGet) {
  getMethodByCallBack(`api/CustomersAPI/GetCustomerByID?Id=${id}`, cacheTypes.NoCache, onGet, "GetCustomerByID");
}
export function setCurrentCustomer(data) {
  return dispatch =>
    dispatch({
      type: "FETCH_CUSTOMER",
      data: data
    })
}

export function setNewPassword(data, fn) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    //let mobile = data.StringValue;
    data = JSON.stringify(data);
    fetch(serverUrl + "api/CustomersAPI/SetNewPassword", {
      headers: getheader(),
      body: data,
      method: "POST"
    }).then(resp => resp.json())
      .then(resp => {
        dispatch({
          type: "LOADING",
          data: false
        });
        if (resp === "Success") {
          localStorage.removeItem('token');
          alert("عملیات با موفقیت انجام شد. از نرم افزار خارج شده و دوباره وارد شوید");
        }
        else if (resp.Message === "Error") {
          alert("اشکال در انجام عملیات");
        }
        else if (resp.Message === "NotFound") {
          alert("کاربری با این مشخصات در سیستم وجود ندارد");
        }
        else if (resp.Message === "IsBlackListed") {
          alert("این کاربری در لیست سیاه قرار دارد");
        }
        else if (resp.Message === "IsNotActive") {
          alert("این کاربری فعال نیست");
        }
        if (fn !== undefined) {
          fn();
        }
      }).catch(e => {
        dispatch({
          type: "LOADING",
          data: false
        });
        console.log("[REQUEST_PASS]", e);
        alert("اشکال در انجام عملیات");
      })
  }
}
export function forgetPassword(data, fn) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    let mobile = data.StringValue;
    data.ID = 0;
    data.Value = 0;
    data = JSON.stringify(data);
    fetch(serverUrl + "api/CustomersAPI/ForgetPassword", {
      headers: {
        // 'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'credentials': 'include'
      },
      body: data,
      method: "POST"
    }).then(resp => resp.json())
      .then(resp => {
        dispatch({
          type: "LOADING",
          data: false
        });
        if (resp === "Success") {
          localStorage.removeItem('token');
          alert(`رمز جدید به شماره موبایل ${mobile} ارسال شد`);
        }
        else if (resp.Message === "Error") {
          alert("اشکال در انجام عملیات");
        }
        else if (resp.Message === "NotFound") {
          alert("کاربری با این مشخصات در سیستم وجود ندارد");
        }
        else if (resp.Message === "IsBlackListed") {
          alert("این کاربری در لیست سیاه قرار دارد");
        }
        else if (resp.Message === "IsNotActive") {
          alert("این کاربری فعال نیست");
        }
        if (fn !== undefined) {
          fn();
        }
      }).catch(e => {
        dispatch({
          type: "LOADING",
          data: false
        });
        console.log("[REQUEST_PASS]", e);
        alert("اشکال در انجام عملیات");
      })
  }
}
export function searchCustomer(data, forSelect) {
  const searchType = forSelect ? "SEARCH_CUSTOMER_4SELECT" : "SEARCH_CUSTOMER";
  return dispatch => {
    dispatch({
      type: searchType,
      data: "PENDING"
    });
    dispatch({
      type: "SET_CUSTSEARCH_FILTER",
      data: data
    });
    fetch(serverUrl + "api/CustomersAPI/GetCustomerByFilter", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "جستجوی مشتریان");
        }
        dispatch({
          type: searchType,
          data: res
        })
      }).catch(e => console.log("SEARCH_CUSTOMER", e));
  }
}
export function searchCustomer_GetMobiles(data, onGetMobiles) {
  postMethodByCallBack("api/CustomersAPI/GetCustomerMobilesByFilter", data, onGetMobiles, "SEARCH_CUSTOMER_MOBILES");
}
export function searchCustomer4Modal(data, onGetData) {
  // if (((data.Name ?? "") === "") &&
  //   ((data.FirstName ?? "") === "") &&
  //   ((data.NameOrFirstName ?? "") === "") &&
  //   ((data.Code ?? "") === "") &&
  //   ((data.NationalCode ?? "") === "") &&
  //   ((data.SubscriptionCode ?? "") === "") &&
  //   ((data.Address ?? "") === "") &&
  //   ((data.Mobile ?? "") === "")) {
  //   onGetData({ Error: "هیچکدام از کادرهای جستجو پر نشده است" });
  //   return;
  // }
  onGetData("PENDING");
  const apiPath = /*data.InvoiceCustomers ?*/ "SearchInvoiceCustomers" /*: "GetCustomerByFilter"*/;
  fetch(serverUrl + `api/CustomersAPI/${apiPath}`, {
    headers: getheader(),
    body: JSON.stringify(data),
    method: "POST"
  }).then(res => res.json())
    .then(res => {
      if (res.Message) {
        onGetData({ Error: translateError(res.Message) });
        return;
      }
      onGetData(res);
    }).catch(e => console.log("SEARCH_CUSTOMER", e));
}
export function checkNationalCode(NationalCode) {
  if (NationalCode.length === 10) {
    if (NationalCode === '1111111111' ||
      NationalCode === '0000000000' ||
      NationalCode === '2222222222' ||
      NationalCode === '3333333333' ||
      NationalCode === '4444444444' ||
      NationalCode === '5555555555' ||
      NationalCode === '6666666666' ||
      NationalCode === '7777777777' ||
      NationalCode === '8888888888' ||
      NationalCode === '9999999999') {
      return false;
    }
    let c = parseInt(NationalCode.charAt(9));
    let n = parseInt(NationalCode.charAt(0)) * 10 +
      parseInt(NationalCode.charAt(1)) * 9 +
      parseInt(NationalCode.charAt(2)) * 8 +
      parseInt(NationalCode.charAt(3)) * 7 +
      parseInt(NationalCode.charAt(4)) * 6 +
      parseInt(NationalCode.charAt(5)) * 5 +
      parseInt(NationalCode.charAt(6)) * 4 +
      parseInt(NationalCode.charAt(7)) * 3 +
      parseInt(NationalCode.charAt(8)) * 2;
    let r = n - parseInt(n / 11) * 11;
    if (!((r === 0 && r === c) || (r === 1 && c === 1) || (r > 1 && c === 11 - r))) {
      return false;
    }
    else {
      return true;
    }
  }
  else {
    return false;
  }

}
export function getCustomerBaseInfoes() {
  return dispatch => {
    dispatch({
      type: "CUSTOMER_BASE_INFO",
      data: "PENDING"
    });
    fetch(serverUrl + "api/CustomersAPI/GetCustomerBaseInfoes", {
      headers: getheader(),
      method: "GET",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "دریافت اطلاعات");
          res = null;
        }
        dispatch({
          type: "CUSTOMER_BASE_INFO",
          data: res
        });
      }).catch(e => {
        console.log("[CUSTOMER_BASE_INFO]", e);
        dispatch({
          type: "CUSTOMER_BASE_INFO",
          data: null
        });
      })
  }
}
export function getLastCustomerCode(onGet) {
  getMethodByCallBack("api/CustomersAPI/GetLastCustomerCode", cacheTypes.NoCache, onGet, "GetLastCustomerCode");
}
export function deleteCustomer(id, fn) {
  const data = { customerID: id };
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/DeleteCustomer", {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(id)
    }).then(res => res.json())
      .then(res => {
        setErrorDialog(dispatch, res.Message, "حذف مشتری");
        if (res.Result) {
          fn();
        }
      })
  }
}
export function addNewCustomerStatus(data, fn) {
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/AddNewCustomerStatus", {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data)
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ثبت وضعیت مشتری");
          return;
        }
        setErrorDialog(dispatch, "success", "ثبت وضعیت مشتری");
        if (fn) {
          fn(res);
        }
      })
  }
}
export function editCustomerStatus(data, onEdit) {
  postMethodByCallBack(`api/CustomersAPI/EditCustomerStatus`, data, onEdit, "EditPreCustomerStatus");
}
export function deleteCustomerStatus(id, fn) {
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/DeleteCustomerStatus", {
      headers: getheader(),
      method: "POST",
      body: id
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "حذف وضعیت مشتری");
          return;
        }
        setErrorDialog(dispatch, "success", "حذف وضعیت مشتری");
        if (fn) {
          fn(id);
        }
      });
  }
}
export function getCustomerStatusList(fn) {
  fetch(serverUrl + "api/CustomersAPI/GetCustomerStatusList", {
    headers: getheader(),
    method: "GET"
  }).then(res => res.json())
    .then(res => {
      if (res.Message) {
        res = [];
      }
      fn(res);
    });
}
export function getCustomerEvents(data) {
  return dispatch => {
    dispatch({
      type: "CUSTOMER_EVENTS",
      data: "PENDING"
    });
    fetch(serverUrl + "api/CustomersAPI/GetCustomerEvents", {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data)
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "رویدادهای مشتری");
          res = null;
        }
        dispatch({
          type: "CUSTOMER_EVENTS",
          data: res
        });
      }).catch(e => {
        console.log("[CUSTOMER_EVENTS]", e);
      })
  }
}
export function loadEventsHistory(data) {
  if (!data.IsPreCustomer && !data.IsCustomer) {
    data.IsPreCustomer = data.IsCustomer = true;
  }
  return dispatch => {
    dispatch({
      type: "EVENTS_HISTORY",
      data: "PENDING"
    });
    //Save Filters
    dispatch({
      type: "EVENTS_HISTORY_FILTER",
      data: data
    });
    fetch(serverUrl + "api/CustomersAPI/LoadEventsHistory", {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data)
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "تاریخچه رویدادها");
          res = null;
        }
        dispatch({
          type: "EVENTS_HISTORY",
          data: res
        });
      }).catch(e => {
        console.log("[EVENTS_HISTORY]", e);
      })
  }
}
export function getMyNearEvents(attachmentType, onGet) {
  const data = { MyEvents: true, AttachmentType: attachmentType };
  postMethodByCallBack(`api/CustomersAPI/GetEventsNearNextDate`, data, onGet, "GetEventsNearNextDate");
}
export function clearEventHistoryFilter() {
  return dispatch =>
    dispatch({
      type: "EVENTS_HISTORY_FILTER",
      data: {}
    });
}
export function loadLastEvents(data, onGetData) {
  if (!data.IsPreCustomer && !data.IsCustomer) {
    data.IsPreCustomer = data.IsCustomer = true;
  }

  onGetData("PENDING");
  let token = localStorage.getItem("token");
  let sUrl = localStorage.getItem("ServerUrl");
  if (!token || !sUrl) {
    onGetData([]);
    return;
  }
  fetch(sUrl + "api/CustomersAPI/LoadEventsHistory", {
    headers: getheader(),
    method: "POST",
    body: JSON.stringify(data)
  }).then(res => res.json())
    .then(res => {
      if (res.Message) {
        res.Error = translateError(res.Message);
      }
      onGetData(res);
    }).catch(e => {
      console.log("[EVENTS_HISTORY]", e);
    })
}
export function getEventTypeList() {
  return dispatch => {
    dispatch({
      type: "EVETN_TYPES",
      data: "PENDING"
    });
    fetch(serverUrl + "api/BaseInfoAPI/GetEventTypeList", {
      headers: getheader(),
      method: "GET",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          res = null
        }
        dispatch({
          type: "EVETN_TYPES",
          data: res
        });
      })
  }
}
export function getEventTypeListWithCallback(onGet) {
  getMethodByCallBack(`api/BaseInfoAPI/GetEventTypeList`, cacheTypes.NoCache, onGet, "GetEventTypeList");
}
export function addNewEvent(data, fn) {
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/AddCustomerEvent", {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data)
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ثبت رویداد");
          return;
        }
        if (!isNaN(res)) {
          setErrorDialog(dispatch, "success", "ثبت رویداد");
        }
        else {
          setErrorDialog(dispatch, "خطای نامشخص", "ثبت رویداد");
        }
        if (fn) {
          fn(res);
        }
      })
  }
}
export function deleteEvent(id, fn) {
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/DeleteEvent", {
      headers: getheader(),
      method: "POST",
      body: id
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "حذف رویداد");
          return;
        }
        setErrorDialog(dispatch, "success", "حذف رویداد");
        if (fn) {
          fn(res);
        }
      })
  }
}
export function verifyEvent(id, fn) {
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/VerifyEvent", {
      headers: getheader(),
      method: "POST",
      body: id
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "بررسی رویداد");
          return;
        }
        if (fn) {
          fn(res);
        }
      })
  }
}
export function getAttachmentList(id, attachmentType) {
  return dispatch => {
    dispatch({
      type: "CUSTOMER_ATTACHMENTS",
      data: "PENDING"
    });
    fetch(serverUrl + `api/Attachments/GetAttachmentList?parentID=${id}&attachmentType=${attachmentType}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          res = null;
        }
        dispatch({
          type: "CUSTOMER_ATTACHMENTS",
          data: res
        });
      })
  }
}
export function getRemainedAccount(id, cat, fn) {
  fetch(serverUrl + `api/DocumentsAPI/GetRemainedAccount?accountID=${id}&accountCat=${cat}`, {
    headers: getheader(),
    method: "GET",
    cache: "no-cache"
  }).then(res => res.json())
    .then(res => {
      if (fn) {
        fn(res);
      }
    }
    ).catch(e => {
      console.log("[GetRemainedAccount]", e);
      const r = { RemainedAccount: -1, Type: "", color: "black" }
      fn(r);
    })
}
export function getPreCustomerBaseInfoes() {
  return dispatch => {
    dispatch({
      type: "PRECUSTOMER_BASE_INFO",
      data: "PENDING"
    });
    fetch(serverUrl + "api/CustomersAPI/GetPreCustomerBaseInfoes", {
      headers: getheader(),
      method: "GET",
      cache: "default"
    }).then(res => { console.log(res); return res.json(); })
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "دریافت اطلاعات");
          res = null;
        }
        dispatch({
          type: "PRECUSTOMER_BASE_INFO",
          data: res
        });
      }).catch(e => {
        console.log("[PRECUSTOMER_BASE_INFO]", e);
        dispatch({
          type: "PRECUSTOMER_BASE_INFO",
          data: null
        });
      })
  }
}
export function addNewPreCustomer(data, fn, onError) {

  return dispatch => {
    const _header = getheader();
    let customer = data;
    data = JSON.stringify(data);
    fetch(serverUrl + "api/CustomersAPI/AddPreCustomer/", {
      body: data,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "مشتری بالقوه");
          onError();
          return;
        }

        customer.ID = Number(res.ID);
        dispatch({
          type: "FETCH_PRECUSTOMER",
          data: customer
        });
        fn(customer);
        setErrorDialog(dispatch, "success", "ایجاد مشتری بالقوه");
      }).catch(err => {
        console.error('[ADD_CUSTOMER]', err);
        setErrorDialog(dispatch, err.message, "مشتری بالقوه");
        onError();
      });
  }
}
export function addNewPreCustomers(data, updateFoundItems, fn) {

  return dispatch => {
    const _header = getheader();
    let customer = data;
    data = JSON.stringify(data);
    fetch(serverUrl + "api/CustomersAPI/AddPreCustomers/" + updateFoundItems, {
      body: data,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ثبت گروهی مشتریان بالقوه");
          return;
        }

        if (fn) {
          fn(customer);
        }
        setErrorDialog(dispatch, "success", "ثبت گروهی مشتریان بالقوه");
      }).catch(err => {
        console.error('[ADD_PRECUSTOMERS]', err);
        setErrorDialog(dispatch, "error", "ثبت گروهی مشتریان بالقوه");
      });
  }
}
export function getPreCutomer(id, onGet) {
  postMethodByCallBack("api/CustomersAPI/GetPreCustomer", id, onGet, "GetPreCustomer");
}
export function editPreCustomer(data, fn, onError) {
  const _header = getheader();
  const customer = { ...data };
  data = JSON.stringify(data);
  return dispatch => {

    fetch(serverUrl + "api/CustomersAPI/EditPreCustomer/", {
      body: data,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ویرایش اطلاعات مشتری");
          onError();
          return;
        }
        dispatch({
          type: "FETCH_PRECUSTOMER",
          data: customer
        });
        setErrorDialog(dispatch, "success", "ویرایش اطلاعات مشتری");
        if (fn) {
          fn();
        }
      }).catch(err => {
        console.error('[Edit_PRECUSTOMER]', err);
        setErrorDialog(dispatch, err.message, "ویرایش اطلاعات مشتری");
        onError();
      });
  }
}
export function searchPreCustomer(data, forSelect) {
  const _header = getheader();
  const postData = JSON.stringify(data);
  const searchType = forSelect ? "SEARCH_PRECUSTOMER_4SELECT" : "SEARCH_PRECUSTOMER";
  return dispatch => {
    if (data) {
      dispatch({
        type: "PRECUST_SEARCH_FILTERS",
        data: data
      })
    }
    dispatch({
      type: searchType,
      data: "PENDING"
    })
    fetch(serverUrl + "api/CustomersAPI/SearchPreCustomer/", {
      body: postData,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "جستجوی مشتریان بالقوه");
          return;
        }
        dispatch({
          type: searchType,
          data: res
        })
      }).catch(err => {
        console.error(searchType, err);
      });
  }
}
export function searchPreCustomer_GetMobiles(data, onPostData) {
  postMethodByCallBack("api/CustomersAPI/SearchPreCustomer_GetMobiles", data, onPostData, "SEARCH_PRECUSTOMER_MOBILES");
}
export function deletePreCustomer(id, fn) {
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/DeletePreCustomer", {
      headers: getheader(),
      method: "POST",
      body: id
    }).then(res => res.json())
      .then(res => {
        setErrorDialog(dispatch, res.Message, "حذف مشتری");
        if (res.Result) {
          fn();
        }
      })
  }
}
export function addPreCustomerProduct(data, fn) {
  return dispatch => {
    const _header = getheader();
    let product = { ...data };
    data = JSON.stringify(data);
    fetch(serverUrl + "api/CustomersAPI/AddPreCustomerProduct/", {
      body: data,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "محصولات درخواستی بالقوه");
          return;
        }

        product.ID = Number(res.ID);
        fn(product);
        setErrorDialog(dispatch, "success", "محصولات درخواستی مشتری بالقوه");
      }).catch(err => {
        console.error('[ADD_PRECUSTOMER_PRODUCT]', err);
      });
  }
}
export function getPreCustomerProductList_Local(data) {
  return dispatch => {

    dispatch({
      type: "PRECUSTOMER_PRODUCT_LIST",
      data: data
    })
  }
}
export function getPreCustomerProductList(preCustomerID, isPreCustomer) {
  return dispatch => {

    dispatch({
      type: "PRECUSTOMER_PRODUCT_LIST",
      data: "PENDING"
    })
    fetch(serverUrl + `api/CustomersAPI/GetPreCustomerProductList?customerID=${preCustomerID}&isPreCustomer=${isPreCustomer}`, {
      headers: getheader(),
      method: "GET",
      cache: "default"
    })
      .then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "لیست محصولات مشتریان بالقوه");
          return;
        }
        dispatch({
          type: "PRECUSTOMER_PRODUCT_LIST",
          data: res
        })
      }).catch(err => {
        console.error('[PRECUSTOMER_PRODUCT_LIST]', err);
      });
  }
}
export function deletePreCustomerProduct(id, fn) {
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/DeletePreCustomerProduct", {
      headers: getheader(),
      method: "POST",
      body: id
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "حذف محصول درخواستی");
          return;
        }
        setErrorDialog(dispatch, "success", "حذف محصول درخواستی");
        if (fn) {
          fn(res);
        }
      })
  }
}
export function convertPreCustomerToCustomer(data, fn) {
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/ConvertPreCustomerToCustomer", {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data)
    }).then(res => res.json())
      .then(res => {
        setErrorDialog(dispatch, res.Message, "تبدیل مشتری بالقوه");
        if (res.ID > 0 && fn) {
          fn(res);
        }
      })
  }
}
export function addNewPreCustomerStatus(data, fn) {
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/AddNewPreCustomerStatus", {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data)
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ثبت وضعیت مشتری بالقوه");
          return;
        }
        setErrorDialog(dispatch, "success", "ثبت وضعیت مشتری بالقوه");
        if (fn) {
          fn(res);
        }
      })
  }
}
export function editPreCustomerStatus(data, onEdit) {
  postMethodByCallBack(`api/CustomersAPI/EditPreCustomerStatus`, data, onEdit, "EditPreCustomerStatus");
}
export function deletePreCustomerStatus(id, fn) {
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/DeletePreCustomerStatus", {
      headers: getheader(),
      method: "POST",
      body: id
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "حذف وضعیت مشتری بالقوه");
          return;
        }
        setErrorDialog(dispatch, "success", "حذف وضعیت مشتری بالقوه");
        if (fn) {
          fn(id);
        }
      });
  }
}
export function getPreCustomerStatusList(fn) {
  fetch(serverUrl + "api/CustomersAPI/GetPreCustomerStatusList", {
    headers: getheader(),
    method: "GET"
  }).then(res => res.json())
    .then(res => {
      if (res.Message) {
        res = [];
      }
      fn(res);
    });
}
export function getCampaignStageList() {
  return dispatch => {
    dispatch({
      type: "CAMPAIGN_STAGE_LIST",
      data: "PENDING"
    });
    fetch(serverUrl + "api/WorkflowAPI/GetStageList?entityType=SaleCampaign", {
      headers: getheader(),
      method: "GET",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          res = [];
        }
        dispatch({
          type: "CAMPAIGN_STAGE_LIST",
          data: res
        });
      }).catch(e => console.log("[CAMPAIGN_STAGE_LIST]", e));
  }
}
export function addNewCampaign(data, fn) {
  return dispatch => {
    fetch(serverUrl + "api/SaleCampaignAPI/AddNewCampaign", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "کمپین جدید");
          return;
        }
        setErrorDialog(dispatch, "success", "کمپین جدید");
        if (fn) {
          fn();
        }
      }).catch(e => console.log("[AddNewCampaign]", e));
  }
}
/**
 * 
 * @param {bigint} id 
 * @param {datetime} date 
 */
export function extendCampaingExpiration(id, date, onExtend) {
  getMethodByCallBack(`api/SaleCampaignAPI/ExtendCampaingExpiration?campaignID=${id}&date=${date}`, cacheTypes.NoCache, onExtend, "ExtendCampaingExpiration");
}
export function editSaleCampaign(data, fn) {
  return dispatch => {
    fetch(serverUrl + "api/SaleCampaignAPI/EditSaleCampaign", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ویرایش کمپین");
          return;
        }
        setErrorDialog(dispatch, "success", "ویرایش کمپین");
        if (fn) {
          fn();
        }
      }).catch(e => console.log("[EditSaleCampaign]", e));
  }
}
export function getCampaignList(data) {
  return dispatch => {
    dispatch({
      type: "CAMPAIGN_LIST",
      data: "PENDING"
    });
    fetch(serverUrl + "api/SaleCampaignAPI/SearchCampaigns", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          res = [];
        }
        dispatch({
          type: "CAMPAIGN_LIST",
          data: res
        });
      }).catch(e => console.log("[CAMPAIGN_LIST]", e));
  }
}
export function getCampaign(campaignID, fn) {
  return dispatch => {
    fetch(serverUrl + "api/SaleCampaignAPI/GetCampaign", {
      headers: getheader(),
      body: Number(campaignID),
      method: "POST"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "دریافت اطلاعات کمپین فروش");
          res = null;
        }
        if (fn) {
          fn(res);
        }

      }).catch(e => console.log("[CAMPAIGN_LIST]", e));
  }

}
export function getCampaignCustomerList(campaignID, fn) {
  fetch(serverUrl + `api/SaleCampaignAPI/GetCampaignCustomerList?campaignID=${campaignID}`, {
    headers: getheader(),
    cache: "no-cache",
    method: "GET"
  }).then(res => res.json())
    .then(res => {
      if (res.Message) {
        res = [];
      }
      fn(res);
    }).catch(e => console.log("[GetCampaignCustomerList]", e));
}
export function addCustomerToCampaign(data, fn) {
  return dispatch => {
    fetch(serverUrl + "api/SaleCampaignAPI/AddToCampaign", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "مشتریان کمپین");
          res = [];
        }
        setErrorDialog(dispatch, "success", "مشتریان کمپین");
        if (fn) {
          fn(res);
        }
      }).catch(e => console.log("[AddToCampaign]", e));
  }
}
export function changeCampaignCustomersStatus(data, fn) {
  return dispatch => {
    fetch(serverUrl + "api/SaleCampaignAPi/ChangeCampaignCustomersStatus", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "تغییر وضعیت مشتریان");
          return;
        }
        setErrorDialog(dispatch, "success", "تغییر وضعیت مشتریان");
        if (fn) {
          fn(res.ListData);
        }
      }).catch(e => console.log("[ChangeCampaignCustomersStatus]", e));
  }
}
export function getCustomerRelatedSections(customerID, isPreCustomer, fn) {
  fetch(serverUrl + `api/CustomersAPI/GetRelatedSections?customerID=${customerID}&isPreCustomer=${isPreCustomer}`, {
    headers: getheader(),
    method: "GET",
    cache: "no-cache"
  }).then(res => res.json())
    .then(res => {
      if (res.Message) {
        res = []
      }
      fn(res);
    }).catch(e => console.log("[GetRelatedSections]", e));
}
export function addRelatedSection(data, fn) {
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/AddNewSection", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "بخش های مرتبط");
          return;
        }
        if (fn) {
          fn(res);
        }
      }).catch(e => console.log("[AddNewSection]", e));
  }
}
export function deleteRelatedSection(id, fn) {
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/DeleteRelatedSection", {
      headers: getheader(),
      body: id,
      method: "POST"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "حذف بخش داخلی مشتری");
          return;
        }
        if (fn) {
          fn(res);
        }
      }).catch(e => console.log("[DeleteRelatedSection]", e));
  }
}
export function checkExpiredCampaigns() {
  return dispatch => {
    fetch(serverUrl + "api/SaleCampaignAPI/CheckExpiredCampaigns", {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        {
          if (res.Message) {
            setErrorDialog(dispatch, "بررسی وضعیت کمپین ها با مشکل مواجه شد", "کمپین فروش");
          }
          else if (Number(res) > 0) {
            const msg = "تعداد " + res + " مشتری و مشتری بالقوه از کمپین خارج شدند";
            setErrorDialog(dispatch, msg, "کمپین فروش");
          }
        }
      }).catch(e => console.log("[CHECK_EXPIRED_CAMPAIGNS]", e));
  }
}
export function setCustomerSearchFilter(data, fn) {
  return dispatch => {
    dispatch({
      type: "SET_CUSTSEARCH_FILTER",
      data: data
    });
    if (fn) {
      fn();
    }
  }
}
export function setPreCustomerSearchFilter(data, fn) {
  return dispatch => {
    dispatch({
      type: "PRECUST_SEARCH_FILTERS",
      data: data
    });
    if (fn) {
      fn();
    }
  }
}
export function newCustomersPerYearOrMonth(monthly, persianYear, onGetData) {
  let token = localStorage.getItem("token");
  let sUrl = localStorage.getItem("ServerUrl");
  if (!token || !sUrl) {
    onGetData([]);
    return;
  }
  onGetData("PENDING");
  fetch(sUrl + `api/CRMReportsAPI/NewCustomersPerYearOrMonth?monthly=${monthly}&persianYear=${persianYear}`, {
    headers: { "Token": token },
    method: "GET",
    cache: "default"
  }).then(res => res.json())
    .then(res => {
      if (res.Message) {
        onGetData({ Error: translateError(res.Message) });
      }
      else {
        onGetData(res);
      }
    }).catch(e => {
      onGetData([]);
      console.log("[NEW_CUSTOMERS_PER_YEAR]", e);
    })
}
export function callCountPerMonth(persianYear, onGetData) {
  let token = localStorage.getItem("token");
  let sUrl = localStorage.getItem("ServerUrl");
  if (!token || !sUrl) {
    onGetData([]);
    return;
  }
  onGetData("PENDING");
  fetch(sUrl + `api/CRMReportsAPI/CallCountPerMonth?persianYear=${persianYear}`, {
    headers: { "Token": token },
    method: "GET",
    cache: "default"
  }).then(res => res.json())
    .then(res => {
      if (res.Message) {
        onGetData({ Error: translateError(res.Message) });
      }
      else {
        onGetData(res);
      }
    }).catch(e => {
      onGetData([]);
      console.log("[NEW_CUSTOMERS_PER_YEAR]", e);
    })
}
export function addCustomerTicket(ticket, fn) {
  postMethodByCallBack(`api/CustomersAPI/AddCustomerTicket`, ticket, fn, "ADD_CUSTOMER_TICKET");
}
export function closeCustomerTicket(id, fn) {
  getMethodByCallBack(`api/CustomersAPI/CloseTicket?id=${id}`, cacheTypes.NoCache, fn, "CLOSE_CUSTOMER_TICKET");
}
export function deleteCustomerTicket(id, fn) {
  getMethodByCallBack(`api/CustomersAPI/DeleteTicket?id=${id}`, cacheTypes.NoCache, fn, "DELETE_CUSTOMER_TICKET");
}
export async function updateTicketPriority(id, priority, onUpdate) {
  const result = await getMethod(`api/CustomersAPI/UpdatePriority?id=${id}&priority=${priority}`, cacheTypes.NoCache, "UpdateTicketPriority");
  return result;
}
export function getCustomerTicket(id, fn) {
  getMethodByCallBack(`api/CustomersAPI/GetCustomerTicket?byCustomer=false&id=${id}`, cacheTypes.NoCache, fn, "GET_CUSTOMER_TICKET");
}
export function getCustomerTicketList(filters) {
  return dispatch => dispatch(postMethodByDispatcher("api/CustomersAPI/GetCustomerTicketList", filters, "GET_CUSTOMER_TICKETS", "لیست تیکت"));
}
export function getCustomerTicketList_Local(data) {
  return dispatch => {
    dispatch({
      type: "GET_CUSTOMER_TICKETS",
      data: data
    })
  }
}
export function getCustomerGroups(onGet) {
  getMethodByCallBack(`api/CustomerGroupAPI/GetCustomerGroups?isActive=true`, cacheTypes.NoCache, onGet, "GetCustomerGroups");
}
export function addEditCustomerGroup(data, onUpdate) {
  postMethodByCallBack(`api/CustomerGroupAPI/AddOrUpdateCustomerGroups?takeList=true`, data, onUpdate, "AddOrUpdateCustomerGroups");
}
export function deleteCustomerGroup(id, onDelete) {
  return () => getMethodByCallBack(`api/CustomerGroupAPI/DeleteCustomerGroup?id=${id}&takeList=true`, cacheTypes.NoCache, onDelete, "DeleteCustomerGroup");
}
export function searchCallHistory(data, onGet) {
  return dispatch => dispatch(postMethodByDispatcher(`api/CRMReportsAPI/SearchCallHistory`, data, "CALL_HISTORY", "تاریخچه تماسها", onGet));
}
export function getPreCustomerJobList(onGet) {
  getMethodByCallBack(`api/CustomersAPI/GetPreCustomerJobList`, cacheTypes.NoCache, onGet, "GetPreCustomerJobList");
}
export function addEditPreCustomerJob(data, onAddEdit) {
  postMethodByCallBack(`api/CustomersAPI/AddEditPreCustomerJob`, data, onAddEdit, "AddEditPreCustomerJob");
}
export function deletePreCustomerJob(id, onDelete) {
  getMethodByCallBack(`api/CustomersAPI/DeletePreCustomerJob?id=${id}`, cacheTypes.NoCache, onDelete, "DeletePreCustomerJob");
}
export function addOrUpdateSaleCompetitor(data, onAddUpdate) {
  postMethodByCallBack("api/CustomersAPI/AddOrUpdateSaleCompetitor", data, onAddUpdate, "AddOrUpdateSaleCompetitor");
}
export function deleteSaleCompetitor(id, onDelete) {
  getMethodByCallBack(`api/CustomersAPI/DeleteSaleCompetitor?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteSaleCompetitor");
}
export function getSaleCompetitorList(onGet) {
  getMethodByCallBack("api/CustomersAPI/GetSaleCompetitorList", cacheTypes.NoCache, onGet, "GetSaleCompetitorList");
}
export function callHistoryForDashboard(onGetData) {
  getMethodByCallBack("api/CRMReportsAPI/CallHistoryForDashboard?dateFrom=null&dateTo=null", cacheTypes.NoCache, onGetData, "CallHistoryForDashboard");
}
export async function getCustomerIDFromTicketID(ticketID) {
  if (!ticketID) {
    return;
  }
  const result = await getMethod(`api/CustomersAPI/GetCustomerIDFromTicketID?ticketID=${ticketID}`, cacheTypes.NoCache, "GetCustomerIDFromTicketID");
  if (result?.Data)
    return Number(result.Data);
  return 0;
}
export async function getCustomerIDFromEventID(eventID) {
  if (!eventID) {
    return;
  }
  const result = await getMethod(`api/CustomersAPI/GetCustomerIDFromEventID?eventID=${eventID}`, cacheTypes.NoCache, "GetCustomerIDFromEventID");
    if (result?.Data)
    return Number(result.Data);
  return 0;
}